import React, { forwardRef } from 'react';
import {
  Checkbox as MuiCheckbox,
  CheckboxProps as MuiCheckboxProps,
  FormControlLabel,
  FormControlLabelProps,
} from '@mui/material';

export type CheckboxProps = MuiCheckboxProps & {
  label?: FormControlLabelProps['label'];
  labelPlacement?: FormControlLabelProps['labelPlacement'];
};

export const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(
  ({ label, labelPlacement = 'end', ...otherProps }, ref) => {
    if (label) {
      return (
        <FormControlLabel
          control={<MuiCheckbox {...otherProps} ref={ref} />}
          label={label}
          labelPlacement={labelPlacement}
        />
      );
    }

    return <MuiCheckbox {...otherProps} ref={ref} />;
  }
);

Checkbox.displayName = 'Checkbox';
